import React from 'react';
import PropTypes from 'prop-types';
import { infoDrawerStatusChange, drawerStatusChange, showIntro, setDetail, closeIntro } from 'actions';
import { connect } from 'react-redux';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import SvgIcon from 'material-ui/SvgIcon';
import TopMenu from 'components/TopMenu';
import IntegrationAutosuggest from 'components/IntegrationAutosuggest';
import Button from 'material-ui/Button';

const CONFIG = require('../../../config.json');

const InfoOutlineIcon = props => (
  <SvgIcon {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z" />
  </SvgIcon>
);

const SaveIcon = props => (
  <SvgIcon {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
  </SvgIcon>
);

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getSelected = this.getSelected.bind(this);
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    onSelectNode: PropTypes.func.isRequired,
  };

  openInfo() {
    const { app, dispatch } = this.props;
    if (app.tag) {
      dispatch(infoDrawerStatusChange(!app.infodraweropened));
      dispatch(drawerStatusChange(false));
      dispatch(closeIntro());
    }
  }

  gotoHome() {
    const { dispatch } = this.props;
    dispatch(showIntro());
  }

  handleFilterClick(filter) {
    this.props.handleFilterClick(filter);
  }

  getSelected(selected) {
    const { onSelectNode } = this.props;
    onSelectNode(selected.id);
  }

  saveDisk() {
    location.href = CONFIG.fileURL;
  }

  render() {
    const { app } = this.props;
    return (
      <div className="root">
        <AppBar position="static" className="header">
          <Toolbar>
            <Typography type="title" color="inherit" className="flex">
              <div className="logo" onClick={() => this.gotoHome()}>
                <img src={CONFIG.logo_image} className="logo_image" alt="logo" />
                <div className="title">
                  <div className="logo_title">{CONFIG.logo_title}</div>
                  <div className="logo_subtitle">{CONFIG.logo_subtitle}</div>
                </div>
              </div>
              <div className="menu">
                <TopMenu onHomeClick={() => this.gotoHome()} handleFilterClick={(filter) => this.handleFilterClick(filter)} />
              </div>
              <div className="searchbar">
                <IntegrationAutosuggest nodes={app.allnodes.data} getSelected={this.getSelected} />
                <Button raised className="download-button" onClick={() => this.saveDisk()} >
                  <SaveIcon className="left-icon" />
                  Full Text
                </Button>
                <InfoOutlineIcon className="iconHover" onClick={() => this.openInfo()} />
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./scripts/components/Header.jsx